import {createFileRoute} from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS, ROLES} from "@/lib/auth/roles";
import ArticleEditor from "@/modules/articles/article-editor";
import {ARTICLE_EDIT_PATH, ARTICLES_URL} from "@/utils/urls";

export const Route = createFileRoute(ARTICLE_EDIT_PATH)({
  component: RouteComponent,
  loader: async ({params}) => {
    const {articleId} = params
    return {articleId}
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Reputation', path: '#'},
        {label: 'Articles', path: ARTICLES_URL},
      ],
      children: null,
    }
  },
})

function RouteComponent() {
  const {articleId} = Route.useLoaderData()

  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation
        roles={[ROLES.ROLE_EDIT_FIRM, ROLES.ROLE_VIEW_FIRM]}
        permissions={[PERMISSIONS.IS_FULL_FIRM_OR_NETWORK_VIEW, PERMISSIONS.CAN_ACCESS_ARTICLES]}
        forbiddenFallback={<Unauthorized/>}
      >
        <ArticleEditor articleId={Number(articleId)}/>
      </Authorisation>
    </div>
  )
}
